import React from "react";
import PropTypes from 'prop-types';
import allMedia from "../../images/allMedia.png";
import meHandle from "../../images/meHandle.png";
import record from "../../images/record.png";
import NormalCard from "./NormalCard";
import BaseComponent from "../../../../base/BaseComponent";
import {getMeHandleCount} from "../../../newMediaMatrix/actions/actions";

export default class ScreenCard extends BaseComponent {
    static defaultProps = {
        onClickScreenCard: () => {
        },
    };
    static propTypes = {
        onClickScreenCard: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            firstShowCardSelectedDiv: null,
            secondShowCardSelectedDiv: null,
            selectKey: "totalCount",
            allMediaCount: {},
            meHandleData: {},
        }
    }

    componentDidMount() {
        const observer = new ResizeObserver(e => {
            e.forEach(entry => {
                console.log(entry)
                this.props.onResize(entry.target.offsetHeight);
            });
        });
        const target = document.querySelector('.screen-card');
        target && observer.observe(target);

        this.getAllMediaCount();
        this.getMeHandleCount();
    }

    getAllMediaCount() {
        this.request({
            url: "/cm-sites-media-consumer/position/management/getPositionStatusInfo",
            body: {},
            callBack: (data) => {
                let allMediaCount = {};
                if (data) {
                    allMediaCount = data;
                }
                this.setState({
                    allMediaCount
                })
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    getMeHandleCount() {
        getMeHandleCount({}, (data) => {
            let meHandleData = {};
            if (data) {
                meHandleData = data;
            }
            this.setState({
                meHandleData
            })
        })
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;    //防止内存泄露
        };
    }

    getAllAccountDivs() {
        let {
            positionCount = 0,
            recordedCount = 0,
            noRecordedCount = 0,
            recordingCount = 0,
            noPass = 0,
            cancelRecordCount = 0,
            draftCount = 0,
            waitGetCount = 0,
        } = this.state.allMediaCount;
        const {activityTypeData = []} = this.props;
        let lingQuShow = activityTypeData.filter(item => item.type === 5)?.[0]?.status || false;
        const contentList = [
            {
                key: "totalCount",
                title: "全部账号",
                count: positionCount,
                statusType: -1,
                img: allMedia,
                color: "rgba(40, 188, 136, 1)",
                style: {
                    background: "linear-gradient(270.00deg, #fff 0%, #defff3 100%)",
                    checked: {
                        border: "1px solid #28bc88",
                        borderLeft: "3px solid #28bc88",
                    }
                }
            },
            {
                key: "recordCount",
                title: "已备案",
                count: recordedCount,
                statusType: 0,
                show: true,
                img: record,
                style: {
                    countSize: 20,
                    textSize: 14,
                    width: "25.5%",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: 13,
                    default: {
                        background: "linear-gradient(180.00deg, #37d99f 0%, #28bc88 100%)"
                    },
                    checked: {
                        background: "#2BB786",
                    }
                },
            },
            {
                key: "noRecordCount",
                title: "未备案",
                count: noRecordedCount,
                statusType: 4,
                show: true,
                img: record,
                marginLeft: "1%",
                style: {
                    countSize: 20,
                    textSize: 14,
                    width: "25.5%",
                    color: "#fff",
                    borderRadius: "5px 0 0 5px",
                    padding: 13,
                    default: {
                        background: "linear-gradient(180.00deg, #58b0fb 0%, #3f99f3 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #4292DE 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "auditingCount",
                title: "审核中",
                count: recordingCount,
                statusType: 1,
                show: true,
                style: {
                    countSize: 16,
                    textSize: 12,
                    width: "12%",
                    color: "#fff",
                    padding: 16,
                    default: {
                        background: "linear-gradient(180.00deg, #58b0fb 0%, #3f99f3 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #4292DE 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "auditFailed",
                title: "审核不通过",
                statusType: 2,
                show: true,
                count: noPass,
                style: {
                    countSize: 16,
                    textSize: 12,
                    width: "12%",
                    color: "#fff",
                    padding: 16,
                    default: {
                        background: "linear-gradient(180.00deg, #58b0fb 0%, #3f99f3 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #4292DE 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "deletedCount",
                title: "已注销",
                count: cancelRecordCount,
                statusType: 3,
                show: true,
                style: {
                    countSize: 16,
                    textSize: 12,
                    width: "12%",
                    color: "#fff",
                    padding: 16,
                    default: {
                        background: "linear-gradient(180.00deg, #58b0fb 0%, #3f99f3 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #4292DE 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "draftCount",
                title: "草稿",
                count: draftCount,
                statusType: 5,
                show: true,
                style: {
                    countSize: 16,
                    textSize: 12,
                    width: "12%",
                    color: "#fff",
                    padding: 16,
                    default: {
                        background: "linear-gradient(180.00deg, #58b0fb 0%, #3f99f3 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #4292DE 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "waitGetCount",
                title: "未领取",
                count: waitGetCount,
                statusType: 6,
                show: !!waitGetCount && lingQuShow,
                style: {
                    countSize: 16,
                    textSize: 12,
                    width: "12%",
                    color: "#fff",
                    padding: 16,
                    default: {
                        background: "linear-gradient(180.00deg, #58b0fb 0%, #3f99f3 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #4292DE 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
        ]
        // 确定前三项的宽度
        const fixedWidthItems = contentList.slice(0, 3);
        // 计算剩余项（从第四项开始）的数量和总宽度
        const remainingItems = contentList.slice(3).filter(item => item.show);
        const totalRemainingWidth = remainingItems.reduce((total, item) => {
            return total + (item.show ? 1 : 0); // 只计算show属性为true的项
        }, 0);
        // 计算剩余宽度
        const remainingWidth = fixedWidthItems.reduce((total, item) => {
            return total - parseInt(item.style?.width || 0); // 累加每个项的宽度
        }, 100);
        // 计算每个剩余项的宽度  2 => 外边距
        const newWidth = `${(remainingWidth - 2) / totalRemainingWidth}%`;
        // 更新剩余项的宽度
        const updatedRemainingItems = remainingItems.map((item, index) => {
            return {
                ...item,
                style: {
                    ...item.style,
                    borderRadius: index === remainingItems.length - 1 ? "0 5px 5px 0" : 0,  //最后一项设置borderRadius
                    width: newWidth
                }
            };
        });
        return [...fixedWidthItems, ...updatedRemainingItems];
    }

    getMeHandleDivs() {
        let {
            count = 0,
            newMediaCount = 0,
            auditMediaCount = 0,
            updateMediaCount = 0,
            cancleMediaCount = 0,
            annualMediaCount = 0,
            receiveCount = 0,
            activityList = [],
        } = this.state.meHandleData;
        const MeHandleDivs = [
            {
                key: "totalNeedAuditCount",
                title: "待我处理",
                count: count,
                statusType: "-1",
                img: meHandle,
                color: "rgba(74, 183, 255, 1)",
                style: {
                    background: "linear-gradient(270.00deg, #fff 0%, #d1edff 100%)",
                    checked: {
                        border: "1px solid #4ab7ff",
                        borderLeft: "3px solid #4ab7ff",
                    }
                }
            },
            {
                key: "createMediaCount",
                title: "新增账号",
                count: newMediaCount,
                style: {
                    countSize: 16,
                    textSize: 12,
                    color: "#fff",
                    padding: 16,
                    borderRadius: "5px 0 0 5px",
                    default: {
                        background: "linear-gradient(180.00deg, #9ad7ff 0%, #4ab7ff 100%)",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #58b0fb 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "recordMediaCount",
                title: "已开通备案",
                count: auditMediaCount,
                style: {
                    countSize: 16,
                    textSize: 12,
                    color: "#fff",
                    padding: 16,
                    default: {
                        background: "linear-gradient(180.00deg, #9ad7ff 0%, #4ab7ff 100%)",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #58b0fb 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "updateMediaCount",
                title: "变更信息",
                count: updateMediaCount,
                style: {
                    countSize: 16,
                    textSize: 12,
                    color: "#fff",
                    padding: 16,
                    default: {
                        background: "linear-gradient(180.00deg, #9ad7ff 0%, #4ab7ff 100%)",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #58b0fb 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "cancleMediaCount",
                title: "注销账号",
                count: cancleMediaCount,
                style: {
                    countSize: 16,
                    textSize: 12,
                    color: "#fff",
                    padding: 16,
                    default: {
                        background: "linear-gradient(180.00deg, #9ad7ff 0%, #4ab7ff 100%)",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #58b0fb 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "annualMediaCount",
                title: "年审账号",
                count: annualMediaCount,
                style: {
                    countSize: 16,
                    textSize: 12,
                    color: "#fff",
                    padding: 16,
                    default: {
                        background: "linear-gradient(180.00deg, #9ad7ff 0%, #4ab7ff 100%)",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #58b0fb 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
            {
                key: "pendingCount",
                title: "待接收",
                count: receiveCount,
                style: {
                    countSize: 16,
                    textSize: 12,
                    color: "#fff",
                    padding: 16,
                    borderRadius: "0 5px 5px 0",
                    default: {
                        background: "linear-gradient(180.00deg, #9ad7ff 0%, #4ab7ff 100%)",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    },
                    checked: {
                        background: "linear-gradient(180.00deg, #58b0fb 100%, #0000001a 100%",
                        borderLeft: "1px solid rgb(255,255,255,0.4)",
                    }
                },
            },
        ];
        const initData = new Set([]).add(MeHandleDivs[0]);
        const res = activityList.reduce((pre, current, index) => {
            if (typeof MeHandleDivs[index + 1] === 'object') {
                let item = {};
                if (index === activityList.length - 1) {
                    item = {
                        ...MeHandleDivs[MeHandleDivs.length - 1],
                        count: current?.count || 0,
                        title: current?.name || MeHandleDivs[MeHandleDivs.length - 1].name,
                        statusType: current.type
                    };
                } else {
                    item = {
                        ...MeHandleDivs[index + 1],
                        count: current?.count || 0,
                        title: current?.name || MeHandleDivs[index + 1].name,
                        statusType: current.type
                    };
                }
                pre.add(item);
            }
            return pre
        }, initData)
        return Array.from(res);
    }

    handleDivClick(item, clickType) {
        this.setState({selectKey: item.key}, () => {
            this.props.onClickScreenCard(item, clickType);
            if(clickType === "first") this.getAllMediaCount();
            if(clickType === "second") this.getMeHandleCount();
        });
    };

    clearDivClick = () => {
        this.setState({selectKey: "totalCount"})
    }

    render() {
        const {style} = this.props;
        return (
            <>
                <div style={style} className={"screen-card"}>
                    <div style={{display: "flex"}}>
                        <NormalCard width={"56%"}
                                    contentList={this.getAllAccountDivs()}
                                    selectedDivKey={this.state.selectKey}
                                    handleDivClick={(item) => this.handleDivClick(item, "first")}
                        />
                        <div style={{width: "2%"}}/>
                        <NormalCard width={"42%"}
                                    contentList={this.getMeHandleDivs()}
                                    selectedDivKey={this.state.selectKey}
                                    handleDivClick={(item) => this.handleDivClick(item, "second")}
                        />
                    </div>
                </div>
            </>
        );
    }
}